import { defineComponent as r, computed as o, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as n, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "ba06fbdf-3d55-445a-8d0c-809073adb5bb" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#ba06fbdf-3d55-445a-8d0c-809073adb5bb)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h167v512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M345 0h167v512H345z"
}, null, -1), b = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ r({
  __name: "gn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), d = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), a("title", k, n(t.flagName), 1)) : f("", !0),
        p,
        g,
        v
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  z as default
};
//# sourceMappingURL=gn-9b9f9482.js.map
